import {
    Grid,
    FormControl,
    Box,
  } from "@mui/material";
  import React, { useState } from "react";
  import { useRefresh, useUnselectAll } from "react-admin";
  import { EventBusEventsEnum } from "../../enums/EventBusEventsEnum";
  import EventBus from "../../EventBus";
  import { OneMealService } from "../../services/OneMealService";
  import CkMuiDialog from "./CkMuiDialog/CkMuiDialog";
  import { CustomSnackbarTypes } from "./CustomSnackBar";
  import CircularLoader from "./CircularLoader";
  
  interface InputProps {
    open: boolean;
    setOpen: (open: boolean) => void;
    data: any;
  }
  
  const oneMealService = new OneMealService();
  
  const RemoveCookFromOmsDialog = (props: InputProps) => {
    const refresh = useRefresh();
    const [loading, setLoading] = useState<boolean>(false);
    const unselectAll = useUnselectAll("OneMealService");
  
    const handleClose = () => {
      props.setOpen(false);
    };
  
    return (
      <CkMuiDialog
        isDialogOpen={props.open}
        setDialogOpen={props.setOpen}
        onDialogClose={handleClose}
        title={'Remove Cook'}
        secondaryLabel={"Close"}
        secondaryAction={handleClose}
        isLoading={false}
        primaryLabel="Submit"
        primaryAction={async() => {
            let successCount = 0;
            let failure = 0;
  
            const changeOmsTime = async () => {
              const promises = props?.data.map(async (element: number) => {
                try {
                  setLoading(true);
                  const res = await oneMealService.removeCook(element);
                  if(res){
                    successCount++;
                  }
                } catch (error) {
                  failure++;
                  console.error(error);
                }
              });
  
              await Promise.all(promises);
              setLoading(false);
              EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
                message: `Removed Cook from OMS for ${successCount} orders${failure > 0 ? `, failed for ${failure} orders` : ""}.`,
                type: CustomSnackbarTypes.SUCCESS,
              });
            }
            await changeOmsTime();
            unselectAll();
            refresh();
          }
        }
      >
        <Grid
          container
          spacing={2}
          justifyContent={"space-evenly"}
          style={{ padding: "12px 12px 12px 12px" }}
        >
          {
            loading ? <CircularLoader/> : 
            <Grid item>
            <FormControl style={{ width: "170px", marginTop: "10px" }}>
                <Box fontWeight={'600'} color={'red'}>
                    Are you sure you want to remove the cook?
                </Box>
            </FormControl>
          </Grid>
          }
        </Grid>
      </CkMuiDialog>
    );
  };
  
  export default RemoveCookFromOmsDialog;
  